// extracted by mini-css-extract-plugin
module.exports = {"fields-container":"bFywT","discount-form":"Lxzga","discount":"aPsj9","input":"tWYUB","apply":"_0suk9","error":"sVEPj"};